import { BrandSemanticTokens, BRAND_TOKEN_CSS_VAR } from './brands/brandTokens';

/**
 * Reads themed CSS variables from public/themes/{brand}.css
 * (student.css under [data-brand='student'], hale.css under [data-brand='hale']).
 */
export const tokenVar = (
  _tokens: BrandSemanticTokens,
  key: keyof BrandSemanticTokens,
): string => `var(${BRAND_TOKEN_CSS_VAR[key]})`;

export { BRAND_TOKEN_CSS_VAR };
